import { ElementTransformer } from '@lexical/markdown';
import { $createQuoteNode, $isQuoteNode } from '@lexical/rich-text';
import { PRESERVED_EMPTY_PARAGRAPH_MARKER } from '@main/shared/utils';
import {
  $createParagraphNode,
  $getNodeByKey,
  $isParagraphNode,
  NodeKey,
  ParagraphNode,
} from 'lexical';

const preservedEmptyParagraphKeys = new Set<NodeKey>();

export const PRESERVE_NEWLINES: ElementTransformer = {
  type: 'element',
  dependencies: [ParagraphNode],
  export: (node) => {
    if ($isParagraphNode(node)) {
      const content = node.getTextContent();
      if (!content.trim()) {
        return '\n \n';
      }
    }
    return null;
  },
  regExp: new RegExp(`^${PRESERVED_EMPTY_PARAGRAPH_MARKER}$`),
  replace: (parentNode, nodes, _, isImport) => {
    if (isImport && nodes.length === 1) {
      // 0.50 removes an empty paragraph here; a quote survives cleanup and is replaced afterward.
      const placeholder = $createQuoteNode();
      preservedEmptyParagraphKeys.add(placeholder.getKey());
      parentNode.replace(placeholder);
    }
  },
};

export function restorePreservedEmptyParagraphs() {
  for (const key of preservedEmptyParagraphKeys) {
    const node = $getNodeByKey(key);
    if ($isQuoteNode(node)) {
      node.replace($createParagraphNode());
    }
    preservedEmptyParagraphKeys.delete(key);
  }
}
